import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import VueHead from 'vue-head'
import i18n from './plugins/i18n'
import VueGtm from 'vue-gtm'

Vue.config.productionTip = false

Vue.use(VueHead)

let gtm = window.gtm
Vue.use(VueGtm, {
  id: 'GTM-M96VGVC',
  enabled: true,
  debug: true
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
